"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledGridContent = void 0;
var _GridContent = require("./GridContent");
// TODO: in v9, move styled() from GridContent.jsx to here
var StyledGridContent = _GridContent.GridContent;
exports.StyledGridContent = StyledGridContent;